import Overlay from 'Components/Overlay';
import React from 'react';
import Moment from 'moment';

const formatDate = (value) => (value ? Moment(value).format('DD MMM YYYY, hh:mm A') : '-');

const DetailRow = ({ label, value, fullWidth }) => (
    <div className={`${fullWidth ? 'col-1' : 'col-2'} flex mb-10 pr-20 tLeft`} style={{ alignItems: 'baseline', lineHeight: '20px', boxSizing: 'border-box' }}>
        <div className="label-color fs-13 wt-150 pr-10" style={{ flexShrink: 0 }}>{label}</div>
        <div className="header-dark-color fs-13 fSemibold" style={{ wordBreak: 'break-word', flex: 1, minWidth: 0 }}>{(value !== undefined && value !== null && value !== '') ? value : '-'}</div>
    </div>
);

const Section = ({ title, children }) => (
    <div className="mb-20">
        <div className="theme-color fBold fs-16 mb-10 tLeft">{title}</div>
        <div className="flex flex-wrap bg-white br-5 ph-20 pt-15 pb-5">{children}</div>
    </div>
);

const TransporterDetailsPopup = ({ data, isLoading, error, transporterName, onCancel }) => {
    const details = data || {};
    const gstinList = (details.gstin_details || []).filter(el => el && el.gstin).map(el => el.gstin).join(', ');
    const vendorCodes = (details.sap_vendor_details || []).filter(el => el && el.sap_vendor_code).map(el => el.sap_vendor_code).join(', ');
    return (
        <Overlay>
            <div className="bg-light-blue box-shadow ph-20 pv-20 br-5 tCenter wt-900">
                <div className="mb-10 tCenter fSemibold fs-20 mt-10 mb-20">
                    Transporter Details
                </div>
                <section className="overflowAuto status-table-height ph-10">
                    {isLoading ?
                        <div className="fs-14 label-color pv-20">Loading...</div>
                        :
                        error ?
                        <div className="fs-14 error-color pv-20">{error}</div>
                        :
                        <>
                            <Section title="Transporter">
                                <DetailRow label="Transporter Name" value={details.company_name || transporterName} />
                                <DetailRow label="Status" value={details.is_active === undefined ? '' : (details.is_active ? 'Active' : 'Inactive')} />
                            </Section>
                            <Section title="Company Basic Details">
                                <DetailRow label="Company Name" value={details.company_name} />
                                <DetailRow label="PAN No" value={details.pan_no} />
                                <DetailRow label="Contact" value={details.contact} />
                                <DetailRow label="Email" value={details.email || details.company_email} />
                                <DetailRow label="GSTIN" value={gstinList || details.gstin} />
                                <DetailRow label="Vendor Code" value={vendorCodes || details.sap_vendor_code} />
                                <DetailRow label="State" value={details.state} />
                                <DetailRow label="Zipcode" value={details.zipcode} />
                                <DetailRow label="Address" value={details.company_address} fullWidth />
                            </Section>
                            <Section title="User Details">
                                <DetailRow label="Admin Name" value={details.admin_name} />
                                <DetailRow label="User Email" value={details.user_email} />
                                <DetailRow label="User Contact" value={details.user_contact} />
                                <DetailRow label="Last Login" value={formatDate(details.last_login_on)} />
                            </Section>
                        </>
                    }
                </section>
                <div className="col-1 ht-60 flex flex-middle flex-center">
                    <button className="ht-40 br-5 theme-color border-theme fs-18 fBold wt-150" onClick={onCancel}>Close</button>
                </div>
            </div>
        </Overlay>
    );
};

export default TransporterDetailsPopup;
